// Typed error thrown by the ai-sdk transport (services/sdkClient.ts) so the AI
// Background hooks can react to backend auth / credits failures (open the
// registration / offer screen) once the legacy monetization.pending() gate is gone.

const AUTH_REASONS = ['token_error', 'unauthorized', 'forbidden'];
// 'not-enough-available-feature-uses' is the reason the old monetization.pending()
// returned for an empty balance — keep recognising it for parity.
const CREDITS_REASONS = ['insufficient_credits', 'credits_error', 'payment_required', 'not-enough-available-feature-uses'];

export class ApiError extends Error {
  readonly reason: string;

  readonly statusCode?: number;

  constructor(message: string, reason: string, statusCode?: number) {
    super(message);
    this.name = 'ApiError';
    this.reason = reason;
    this.statusCode = statusCode;
  }

  get isAuthError(): boolean {
    return this.statusCode === 401 || AUTH_REASONS.includes(this.reason);
  }

  get isCreditsError(): boolean {
    return this.statusCode === 402 || CREDITS_REASONS.includes(this.reason);
  }
}

export const isCreditsError = (error: unknown): boolean => error instanceof ApiError && error.isCreditsError;

export const isAuthError = (error: unknown): boolean => error instanceof ApiError && error.isAuthError;
